module.exports = __webpack_public_path__ + "img/logo_kcc_blue_white.911cabe.png";